import { useState, useCallback, useEffect } from 'react';
import useMediaQuery from '@src/hooks/useMediaQuery';

const NAVIGATION_HEIGHT = 58;
const OFFSET_ON_MOBILE_VIEW = 40;

interface IProps {
	tabOptionList: string[];
}

const useSmoothScrollNavigation = ({ tabOptionList }: IProps): {
	activeTabIndex: number;
	handleClickTab: (blockId: string) => void;
} => {
	const { mediaMatch: {
		isMobile,
	} } = useMediaQuery();
	const [activeTabIndex, setActiveTabIndex] = useState(-1);

	const handleClickTab = useCallback(blockId => {
		const targetEle = document.getElementById(blockId);

		window.scrollTo({
			top: targetEle.offsetTop - NAVIGATION_HEIGHT - (isMobile ? OFFSET_ON_MOBILE_VIEW : 0),
			behavior: 'smooth',
		});
	}, [isMobile]);

	const handleUpdateActiveTab = () => {
		const offsetFromPage = tabOptionList.map(tabOption => {
			const tabElem = document.getElementById(tabOption);

			return tabElem.offsetTop - window.pageYOffset;
		});

		/**
		 * Note: Fix navigation tab overfitting bug.
		 * 'NAVIGATION_HEIGHT + 50' is to fix the bug that somehow in some android device would not active precisely.
		*/
		const offsetFromNavigation = offsetFromPage.filter(item => (item <= NAVIGATION_HEIGHT + 50));
		const tabIndex = offsetFromNavigation.indexOf(Math.max(...offsetFromNavigation));

		setActiveTabIndex(tabIndex);
	};

	useEffect(() => {
		document.addEventListener('scroll', handleUpdateActiveTab);

		return () => {
			document.removeEventListener('scroll', handleUpdateActiveTab);
		};
	}, []);

	return {
		activeTabIndex,
		handleClickTab,
	};
};

export default useSmoothScrollNavigation;
